import { formatTime, toFixed } from '../base/CONST';
export default {
  data() {
    return {
      count: 0,
      status: 0,
      payType: '4', // 支付方式：1贡献点、2迷你币、3微信、4支付宝
      title: '购买',
    };
  },
  created() {
    let params = this.$route.params;
    console.log('pay.vue created---', params);
    if (!params || !params.id) {
      params = JSON.parse(localStorage.getItem('payInfo'));
      if (Date.now() - params.cache_time >= 5 * 60000) {
        // 失效
        localStorage.removeItem('payInfo');
        params = null;
      }
    }
    if (params) {
      params.cache_time = Date.now();
      localStorage.setItem('payInfo', JSON.stringify(params));
      const {
        count,
        create_time,
        day,
        money,
        id,
        sub_money,
        txt,
        title,
        payType,
      } = params;
      this.count = count;
      this.createTime = create_time;
      this.day = day;
      this.oriMoney = toFixed(money + (sub_money || 0));
      this.money = toFixed(money);
      this.orderId = id;
      this.subMoney = sub_money ? toFixed(sub_money) : 0;
      this.txt = txt;
      this.title = title;
      this.payType = payType || this.payType;
    }
  },
  filters: {
    formatTime(time) {
      return formatTime(time, true);
    },
  },
};
